
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/faq",
      function () {
        return require("private-next-pages/content/faq/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/faq"])
      });
    }
  